import { Colors } from '@/common/colors/colors';
import styled from 'styled-components';

export const InfoItemsWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
`;

export const Wrapper = styled.div`
	display: flex;
	justify-content: center;
    flex-direction: column;
	flex-wrap: wrap;
	gap: 40px;
	padding: 5px;
	overflow-y: auto;
`;

export const Title = styled.h3`
	color: ${Colors.darkBlue};
`;

export const ButtonsWrapper = styled.div`
	display: flex;
	gap: 10px;
	justify-content: end;
`;